import { EnterpriseThemeInterface } from '@thg-commerce/enterprise-theme'

import { getUniqueObjectArrayByKey, createFullFontFace } from '../utils'
import { FontSpec } from '../types'

export const fontCssStyles = (theme: EnterpriseThemeInterface) => {
  return getUniqueObjectArrayByKey(
    Object.values(theme.typography.urls),
    'family',
  ).reduce((accumulatedStyleString: string, fontStyle: FontSpec) => {
    if (fontStyle.kind === 'cdnfonts#cdn') {
      return `${accumulatedStyleString}${createFullFontFace(
        fontStyle.family,
        fontStyle.fontUrls,
      )}`
    }
    return accumulatedStyleString
  }, '')
}
